import { LoginInfo, RoleName } from "vue-glcommonui";
import { GetterTree } from "vuex";
import { AuthState } from "./state";
import { defineVuexName, MODULES } from "../utils";

const getters: GetterTree<AuthState, any> = {
  isLoggedIn: (state: AuthState): boolean => {
    return state.loginInfo?.loggedin || false;
  },
  //isLoggedIn
  [defineVuexName(MODULES.AUTH.GETTERS.GET_IS_LOGGED_IN)]: (state: AuthState): boolean => {
    return state.loginInfo?.loggedin || false;
  },
  isOnlyParent: (state: AuthState): boolean => {
    if (!state.loginInfo || !state.loginInfo.loggedin) return false;
    return state.loginInfo.profile.roles.indexOf(RoleName.parent) !== -1 && state.loginInfo.profile.roles.indexOf(RoleName.teacher) === -1;
  },
  //isOnlyParent
  [defineVuexName(MODULES.AUTH.GETTERS.GET_IS_ONLY_PARENT)]: (state: AuthState): boolean => {
    if (!state.loginInfo || !state.loginInfo.loggedin) return false;
    return state.loginInfo.profile.roles.indexOf(RoleName.parent) !== -1 && state.loginInfo.profile.roles.indexOf(RoleName.teacher) === -1;
  },
  isOnlyTeacher: (state: AuthState): boolean => {
    if (!state.loginInfo || !state.loginInfo.loggedin) return false;
    return state.loginInfo.profile.roles.indexOf(RoleName.parent) === -1 && state.loginInfo.profile.roles.indexOf(RoleName.teacher) !== -1;
  },
  //isOnlyTeacher
  [defineVuexName(MODULES.AUTH.GETTERS.GET_IS_ONLY_TEACHER)]: (state: AuthState): boolean => {
    if (!state.loginInfo || !state.loginInfo.loggedin) return false;
    return state.loginInfo.profile.roles.indexOf(RoleName.parent) === -1 && state.loginInfo.profile.roles.indexOf(RoleName.teacher) !== -1;
  },
  isParentAndTeacher: (state: AuthState): boolean => {
    if (!state.loginInfo || !state.loginInfo.loggedin) return false;
    return state.loginInfo.profile.roles.indexOf(RoleName.parent) !== -1 && state.loginInfo.profile.roles.indexOf(RoleName.teacher) !== -1;
  },
  //isParentAndTeacher
  [defineVuexName(MODULES.AUTH.GETTERS.GET_IS_PARENT_AND_TEACHER)]: (state: AuthState): boolean => {
    if (!state.loginInfo || !state.loginInfo.loggedin) return false;
    return state.loginInfo.profile.roles.indexOf(RoleName.parent) !== -1 && state.loginInfo.profile.roles.indexOf(RoleName.teacher) !== -1;
  },
  getLoginInfo: (state: AuthState): LoginInfo => {
    return state.loginInfo || ({} as LoginInfo);
  },
  //getLoginInfo
  [defineVuexName(MODULES.AUTH.GETTERS.GET_LOGIN_INFO)]: (state: AuthState): LoginInfo => {
    return state.loginInfo || ({} as LoginInfo);
  },
  username: (state: AuthState): string => {
    return state.loginInfo?.profile.name || "";
  },
  //username
  [defineVuexName(MODULES.AUTH.GETTERS.GET_USERNAME)]: (state: AuthState): string => {
    return state.loginInfo?.profile.name || "";
  },
  userAvatar: (state: AuthState): string => {
    return state.loginInfo?.profile.avatarUrl || "/assets/images/user-default.png";
  },
  userRole: (state: AuthState): string => {
    const rolesOrdering = [
      RoleName.systemAdmin,
      RoleName.globalHead,
      RoleName.trainingAdmin,
      RoleName.regionAdmin,
      RoleName.trainingManager,
      RoleName.trainer,
      RoleName.contentAdmin,
      RoleName.accountManager,
      RoleName.schoolAdmin,
      RoleName.campusAdmin,
      RoleName.teacher,
      RoleName.parent,
      RoleName.contentAdmin,
    ];
    let highestRole = state.loginInfo?.profile.roles[0] || "";
    for (const role of rolesOrdering) {
      if (state.loginInfo?.profile.roles.findIndex((r) => r === role) !== -1) {
        highestRole = role;
        break;
      }
    }
    return highestRole;
  },
  isTeacher: (state: AuthState): boolean => {
    const roles = state.loginInfo?.profile.roles;
    return roles?.includes(RoleName.teacher) || false;
  },
  //isTeacher
  [defineVuexName(MODULES.AUTH.GETTERS.GET_IS_TEACHER)]: (state: AuthState): boolean => {
    const roles = state.loginInfo?.profile.roles;
    return roles?.includes(RoleName.teacher) || false;
  },
  isParent: (state: AuthState): boolean => {
    const roles = state.loginInfo?.profile.roles;
    return roles?.includes(RoleName.parent) || false;
  },
  //isParent
  [defineVuexName(MODULES.AUTH.GETTERS.GET_IS_PARENT)]: (state: AuthState): boolean => {
    const roles = state.loginInfo?.profile.roles;
    return roles?.includes(RoleName.parent) || false;
  },
  userId: (state: AuthState): string => {
    return state.loginInfo?.profile.sub || "";
  },
  //userId
  [defineVuexName(MODULES.AUTH.GETTERS.GET_USER_ID)]: (state: AuthState): string => {
    return state.loginInfo?.profile.sub || "";
  },
  userCountryCode: (state: AuthState): string => {
    return state.loginInfo?.profile.rcc || "";
  },
  //userCountryCode
  [defineVuexName(MODULES.AUTH.GETTERS.GET_USER_COUNTRY_CODE)]: (state: AuthState): string => {
    return state.loginInfo?.profile.rcc || "";
  },
};

export default getters;
